import React from "react";
import { useTranslation } from "react-i18next";
import { HiSparkles } from "react-icons/hi";

interface UnlockBadgeProps {
  className?: string;

  customText?: string;

  onClick?: () => void;
}

export const UnlockBadge: React.FC<UnlockBadgeProps> = ({
  className = "",
  customText,
  onClick,
}) => {
  const { t } = useTranslation();

  const text = customText || t("common.unlock");

  return (
    <div
      translate="no"
      className={`inline-flex items-center bg-gradient-to-r from-amber-400 to-amber-500 text-gray-900 px-2.5 py-0.5 rounded-full text-xs font-bold shadow-sm border border-amber-300 hover:from-amber-500 hover:to-amber-600 transition-all ${
        onClick ? "cursor-pointer" : ""
      } ${className}`}
      onClick={onClick}
    >
      <HiSparkles size={10} className="mr-1 text-amber-700 hidden sm:inline" />
      <span className="text-amber-800">{text}</span>
    </div>
  );
};

export default UnlockBadge;
